import { type ComponentProps } from 'react';

import {
  DialogContent as DialogContentPrimitive,
  DialogTitle as DialogTitlePrimitive
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

const DialogBody = ({
  children,
  className,
  ...props
}: ComponentProps<'div'>) => (
  <div
    className={cn(
      'no-scrollbar -mx-4 -mb-1 max-h-[calc(100dvh-178px)] overflow-y-auto px-4 pb-1',
      className
    )}
    {...props}
  >
    {children}
  </div>
);

const DialogContent = ({
  className,
  ...props
}: ComponentProps<typeof DialogContentPrimitive>) => (
  <DialogContentPrimitive
    className={cn(
      'overflow-hidden',
      className ??
        'w-[992px] max-w-[calc(100%-40px)] outline-none sm:max-w-[calc(100%-40px)]'
    )}
    {...props}
  />
);

const DialogTitle = (
  props: Omit<ComponentProps<typeof DialogTitlePrimitive>, 'className'>
) => (
  <DialogTitlePrimitive
    className="flex items-center gap-x-2"
    {...props}
  />
);

export {
  Dialog,
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTrigger
} from '@/components/ui/dialog';

export { DialogBody, DialogContent, DialogTitle };
